import PropTypes from "prop-types";
import InputField from "../../../components/InputField";
import RadioButton from "../../../components/RadioButton/RadioButton";

import AuthenticationFields from "./AuthenticationFields";
import styles from "./Institution.module.scss";

const InstitutionDetailsSection = ({
  isExisting,
  formData,
  selectedProducts,
  shouldShowDetailsSection,
  shouldShowFTE,
  onConfigurationChange,
  onInputChange,
  onAuthenticationToggle,
  onUrlReferralChange,
}) => {
  const configurationValue = isExisting ? formData.isSameUserBase : formData.isAccountAdmin;

  return (
    <>
      {/* Configuration Question */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          {isExisting
            ? "Will the user base for the additional product/s be the same as the user base for Therapeutic Guidelines? "
            : "Are you the Account Admin? "}
          <span className="red">*</span>
        </h2>
        <div className={styles.radioGroup}>
          <RadioButton
            checked={configurationValue === true}
            onChange={() => onConfigurationChange(true)}
            label="Yes"
            value={true}
            name="configurationQuestion"
          />

          <RadioButton
            checked={configurationValue === false}
            onChange={() => onConfigurationChange(false)}
            label="No"
            value={false}
            name="configurationQuestion"
          />
        </div>
      </section>

      {/* Additional Details - Show based on configuration */}
      {shouldShowDetailsSection && (
        <section className={styles.detailsSection}>
          {/* FTE / Number of Beds / Store Numbers - Show only for New=Yes or Existing=No */}
          {shouldShowFTE && (
            <InputField
              label="FTE / Number of Beds / Store Numbers"
              id="fteNumber"
              name="fteNumber"
              required={false}
              type="text"
              placeholder="e.g., 50 FTE, 200 beds, or 10 stores"
              value={formData.fteNumber}
              onChange={(e) => onInputChange("fteNumber", e.target.value)}
            />
          )}

          {/* Authentication Type */}
          <AuthenticationFields
            authenticationType={formData.authenticationType}
            selectedProducts={selectedProducts}
            ipAddress={formData.ipAddress}
            urlReferrals={formData.urlReferrals}
            openAthensId={formData.openAthensId}
            isExisting={isExisting}
            onAuthenticationToggle={onAuthenticationToggle}
            onInputChange={onInputChange}
            onUrlReferralChange={onUrlReferralChange}
          />

          {/* Comment */}
          <div className={styles.formField}>
            <label className={styles.label}>Comments</label>
            <textarea
              className={styles.textarea}
              placeholder="Add any additional comments..."
              value={formData.comment}
              onChange={(e) => onInputChange("comment", e.target.value)}
              rows={5}
            />
          </div>
        </section>
      )}
    </>
  );
};

InstitutionDetailsSection.propTypes = {
  isExisting: PropTypes.bool.isRequired,
  formData: PropTypes.shape({
    isAccountAdmin: PropTypes.bool,
    isSameUserBase: PropTypes.bool,
    fteNumber: PropTypes.string.isRequired,
    authenticationType: PropTypes.arrayOf(PropTypes.string).isRequired,
    ipAddress: PropTypes.string.isRequired,
    urlReferrals: PropTypes.object.isRequired,
    openAthensId: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
  }).isRequired,
  selectedProducts: PropTypes.arrayOf(PropTypes.string).isRequired,
  shouldShowDetailsSection: PropTypes.bool.isRequired,
  shouldShowFTE: PropTypes.bool.isRequired,
  onConfigurationChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onAuthenticationToggle: PropTypes.func.isRequired,
  onUrlReferralChange: PropTypes.func.isRequired,
};

export default InstitutionDetailsSection;
